import { ChangelogItem } from '@evorait/pace-components';
export const CHANGELOGS: ChangelogItem[] = [
  {
    "version": "5.15.0",
    "summary": [],
    "changes": {
      "FIXED": [
        "Corrected issue leading to conflicting notification status updates on multiple devices [8160].",
        "Corrected issue leading to duplicate submission of material requests [8170].",
        "Corrected issue causing duplicate CRM submissions [8068].",
        "Prevent selection of past times when changing criticality [8277].",
        "Improved layout and formatting of the timesheet [8137]."
      ],
      "ADDED": [
        "Introduced warning message when entering future-dated EOW times [8309].",
        "Enabled support for requesting additional tasks on the same equipment or location [GoT, 7948].",
        "Implemented automatic prefill of serial numbers for rental tools [8211].",
        "In-app changelogs [8280].",
        "Improved mouse interaction on dashboard [8001].",
        "Added support for screenshots for issue reporting [7943].",
        "Enabled quick app upgrade during startup [8262]."
      ],
      "REMOVED": [
        "Removed legacy components related to material returns [8291].",
        "Removed outdated Cordova dependencies [7503].",
        "Removed legacy components specific to Asia [8289].",
        "Removed 'Add material' button from the material return screen [8243].",
        "Removed document feedback button for Astoria forms [8276]."
      ]
    }
  },
  {
    "version": "5.15.1",
    "summary": [],
    "changes": {
      "FIXED": [
        "Resolved an issue that removed newly added address from manual timesheet entries when sharing across devices [8314]."
      ]
    }
  },
  {
    "version": "5.15.2",
    "summary": [],
    "changes": {
      "FIXED": [
        "Mandatory commercial info for both FOC and billable entries in time recording and material sections [8411]."
      ]
    }
  },
  {
    "version": "5.15.3",
    "summary": [
      "FIXED : Resolved SPQ form getting locked for the user."
    ],
    "changes": {}
  },
  {
    "version": "5.16.0",
    "summary": [],
    "changes": {
      "ADDED": [
        "Documentation of reason for not filling the provided protocols [7916]",
        "Support for booking follow-up appointments [8140]",
        "Support for crediting participants of training [8132]",
        "Displaying cut-off times for same-day deliveries [7997]",
        "Proper PACE icon in browser tabs [8286]",
        "Advanced parsing of URLs in SAP long texts [8281]"
      ],
      "FIXED": [
        "Disabling upload/download buttons on the confirmation screen when offline [8006]",
        "Evaluation of used date in measurement equipments [8315]"
      ]
    }
  },
  {
    "version": "5.16.1",
    "summary": [],
    "changes": {
      "FIXED": [
        "Disabling the missing protocol justification."
      ]
    }
  },
  {
    "version": "5.16.2",
    "summary": [],
    "changes": {
      "FIXED": [
        "Resolved an issue with the missing protocol submission."
      ]
    }
  },
  {
    "version": "5.16.3",
    "summary": [],
    "changes": {
      "FIXED": [
        "Updated the endpoint urls for get other tasks."
      ]
    }
  },
  {
    "version": "5.17.0",
    "summary": [],
    "changes": {
      "ADDED": [
        "Adding task numbers to the ATS form  [8152]",
        "Display the delivery cutoff time  [7512]",
        "Improving and generalising Azure functions [7977]",
        "Added option to report issues form PACE’s loading screen [8318]",
        "Disabling upload / download on barcode clipboard and timesheet in offline mode  [8337]",
        "Error modal [8335]"
      ],
      "FIXED": [
        "Properly handling State / Province for US  [8239]",
        "Fixing rendering of the bottom action bar on mobile views with long corners [7827]",
        "Fixing state of Start Work functionality  [8330]",
        "Fixing time recording on CRM screen  [8173]"
      ]
    }
  },
  {
    "version": "5.18.0",
    "summary": [],
    "changes": {
      "ADDED": [
        "UI feedback for up- and download actions [8391]",
        "Improved error messages for timesheet [8301]"
      ],
      "FIXED": [
        "Fixing issues with TID details screen [8488]"
      ]
    }
  },
  {
    "version": "5.19.0",
    "summary": [],
    "changes": {
      "FIXED": [
        "CRM Sign Later functionality speed improvement [8388]",
        "(UI) Improved Push Notifications visual guide for clarity [8382]",
        "Shipping Priority issues fixed [8508]",
        "Document Feedback error is now resolved [8522]",
        "Trainee Credit Type US/CAN now made mandatory field [7490]"
      ],
      "ADDED": [
        "Documenting reasons for not filling forms for confirmation [7916].",
        "Corporate Information updated [8500]."
      ]
    }
  },
  {
    "version": "5.19.1",
    "summary": [],
    "changes": {
      "FIXED": [
        "Updating the dashboard after Push Notifications [7490]"
      ]
    }
  },
  {
    "version": "5.20.0",
    "summary": [],
    "changes": {
      "FIXED": [
        "Multiple popups for Authentication [8534]",
        "Attaching screenshots for Reporting Issues [8490]",
        "Short Confirmation transition to Confirm Work [8469]",
        "Cross device Measurement Tools [8468]"
      ],
      "ADDED": [
        "Afterhours Call-Out [7917].",
        "Book appointment [3892]."
      ]
    }
  },
  {
    "version": "5.20.1",
    "summary": [],
    "changes": {
      "FIXED": [
        "Submitting notification after refreshing Details or Confirmation page throws error [8688]",
        "Not able to submit CRM for notifications having FDA forms [8661]"
      ]
    }
  }
];
